var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.745,
    height: 48.745,
    viewBox: "0 0 48.745 48.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bootstrap",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M54.745,47.975a6.769,6.769,0,0,1-6.77,6.77H12.77A6.77,6.77,0,0,1,6,47.975V12.77A6.77,6.77,0,0,1,12.77,6h35.2a6.769,6.769,0,0,1,6.77,6.77Z",
    fill: "#673ab7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M39.413,30.415a6.673,6.673,0,0,0-3.791-2.5,6.1,6.1,0,0,0,2.627-2.37,7.965,7.965,0,0,0,1.124-4.306A7.74,7.74,0,0,0,36.2,14.559,13.322,13.322,0,0,0,27.66,12H15V44.5H29.123c3.832-.027,6.716-.853,8.679-2.437,1.95-1.611,2.925-3.994,2.925-7.176A7.425,7.425,0,0,0,39.413,30.415Zm-16.289-13h5.755a3.724,3.724,0,1,1,0,7.447H23.124Zm6.77,21.664h-6.77V30.956h6.77a4.062,4.062,0,1,1,0,8.124Z",
    transform: "translate(3.186 2.124)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.28b00dca8ab2454b3fa9ab25ec6316cf.svg";
export { ForwardRef as ReactComponent };